export const DIGITAL_SAVINGS_DOCUMENTS_FORM = 'digitalSavings/documentsForm/';

export const DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM + 'setValue/';
export const DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALID = DIGITAL_SAVINGS_DOCUMENTS_FORM + 'setValid/';

export const FORM_VALID_DIGITAL_SAVINGS_DOCUMENTS_FORM = 'digitalSavings/documentsForm/transition/formValid';
export const FORM_INVALID_DIGITAL_SAVINGS_DOCUMENTS_FORM = 'digitalSavings/documentsForm/transition/formInValid';

export const REINITIALIZE = 'digitalSavings/documentsForm/state/reinitialize';

// Dropoff
export const DROP_OFF_LEAD_TRANSITION_DOCUMENTS_FORM = 'digitalSavings/documentsForm/transition/dropOffLead';
export const dropOffLeadDocuments = (value) => ({
    type: DROP_OFF_LEAD_TRANSITION_DOCUMENTS_FORM,
    value,
});

export const transitionDigitalSavingsDocumentsForm = {
    formValid: () => ({
        type: FORM_VALID_DIGITAL_SAVINGS_DOCUMENTS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_DIGITAL_SAVINGS_DOCUMENTS_FORM,
    }),
};

// API Calls actions
export const API_INITIAL_TRANSITION_DOCUMENTS_FORM = `${DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE}/apiTransition/initial`;
export const API_PENDING_TRANSITION_DOCUMENTS_FORM = `${DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_DOCUMENTS_FORM = `${DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_DOCUMENTS_FORM = `${DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE}/apiTransition/failure`;

export const COLLECT_DOCUMENTS_FORM = `${DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE}/apiTransition/collect/documents`;


export const apiTransitionDocumentsForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_DOCUMENTS_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_DOCUMENTS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_DOCUMENTS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_DOCUMENTS_FORM,
    }),
};

//calculated Data
export const COLLECT_DOCUMENTS_FORM_DATA = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'collectDocumentsData';
export const SUBMIT_DOCUMENTS_SUCCESS = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'success';
export const SUBMIT_DOCUMENTS_FAILURE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'failure';

export const collectDocumentsData = () => ({
    type: COLLECT_DOCUMENTS_FORM_DATA,
});
export const submitDocumentsDataSuccess = (value) => ({
    type: SUBMIT_DOCUMENTS_SUCCESS,
    value,
});
export const submitDocumentsFailure = (error) => ({
    type: SUBMIT_DOCUMENTS_FAILURE,
    error,
});

// Form Values
export const ID_UPLOAD_SET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'idUpload';
export const ID_UPLOAD_SET_VALID = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALID + 'idUpload';

export const PASSPORT_SET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'passport';
export const PASSPORT_SET_VALID = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALID + 'passport';

export const KRA_PIN_UPLOAD_SET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'kraPinUpload';
export const KRA_PIN_UPLOAD_SET_VALID = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALID + 'kraPinUpload';

// reset individual form value
export const ID_UPLOAD_RESET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'reset/idUpload';
export const KRA_PIN_UPLOAD_RESET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'reset/kraPinUpload';
export const PASSPORT_UPLOAD_RESET_VALUE = DIGITAL_SAVINGS_DOCUMENTS_FORM_SET_VALUE + 'reset/Passport';

// ID upload action creators
export const setIdUploadValue = (value) => ({
    type: ID_UPLOAD_SET_VALUE,
    value,
});

export const setIdUploadValid = (error) => ({
    type: ID_UPLOAD_SET_VALID,
    error,
});

export const resetIdUploadValue = () => ({
    type: ID_UPLOAD_RESET_VALUE,
});

export const setKraPinUploadValue = (value) => ({
    type: KRA_PIN_UPLOAD_SET_VALUE,
    value,
});

export const setKraPinUploadValid = (error) => ({
    type: KRA_PIN_UPLOAD_SET_VALID,
    error,
});

export const resetKraPinUploadValue = () => ({
    type: KRA_PIN_UPLOAD_RESET_VALUE,
});

export const setPassportUploadValue = (value) => ({
    type: PASSPORT_SET_VALUE,
    value,
});

export const setPassportUploadValid = (error) => ({
    type: PASSPORT_SET_VALID,
    error,
});

export const resetPassportUploadValue = () => ({
    type: PASSPORT_UPLOAD_RESET_VALUE,
});

export const collectUploadDocuments = () => ({
    type: COLLECT_DOCUMENTS_FORM,
});